import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ApiPaginatedResponse,
  ApiQuery,
  apiQueryToHttpParams,
} from '@kinet-open-network/client/core/api-client';
import {
  toModel,
  toModelArray,
} from '@kinet-open-network/client/shared/data-access/model';
import { ILocationPermission } from '@kinet-open-network/shared/data-access/model';
import { Observable, map } from 'rxjs';
import { LocationPermission } from '../models/location-permission.model';

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  private http = inject(HttpClient);

  allowLocation(
    groupId: string,
    locationId: string,
  ): Observable<LocationPermission> {
    return this.http
      .put<{
        data: LocationPermission;
      }>(`/locations/permissions/${groupId}/${locationId}`, null)
      .pipe(map(({ data }) => toModel(data, LocationPermission)));
  }

  disallowLocation(
    groupId: string,
    locationId: string,
  ): Observable<LocationPermission> {
    return this.http
      .delete<{
        data: LocationPermission;
      }>(`/locations/permissions/${groupId}/${locationId}`)
      .pipe(map(({ data }) => toModel(data, LocationPermission)));
  }

  getLocationPermissions(
    groupId: string,
    query?: ApiQuery,
  ): Observable<ApiPaginatedResponse<LocationPermission>> {
    return this.http
      .get<ApiPaginatedResponse<ILocationPermission>>(
        `/locations/permissions/${groupId}`,
        {
          params: apiQueryToHttpParams(query),
        },
      )
      .pipe(
        map(({ data, ...response }) => ({
          ...response,
          data: toModelArray(data, LocationPermission),
        })),
      );
  }

  toggleAccessType(data: ILocationPermission, groupId: string) {
    return this.http.put(
      `/locations/permissions/${groupId}/update-access-type`,
      data,
    );
  }
}
